const columns = [
  {
    label: "Minimalna liczba dni",
    field: "minDaysCount",
    width: 50
  },
  {
    label: "Data rozpoczęcia",
    field: "startDate",
    width: 60
  },
  {
    label: "Data zakończenia",
    field: "endDate",
    width: 60
  }
];

export default columns;
